import { Button } from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { postConsent } from '../services/consent';
import { AppConfig } from '../types/app';
import { HttpError } from '../utils/apiHelper';
import { GandalfUser } from '../types/auth';
import { useNonceGenerator } from '../contexts/NonceGeneratorContextProvider';
import { emitPostAuthRumEvent } from '../services/emitPostAuthRumEvent';
import { PostAuthRumEvent } from '../constants/metrics';

export const AcceptConsent = ({
  onContinue,
  buttonLabel,
  config,
  user,
  setConsentAccepted,
  disabled = false,
  setConsentInProgress,
}: {
  onContinue: () => void;
  buttonLabel: string;
  config: AppConfig;
  user: GandalfUser;
  setConsentAccepted: (isAccepted: boolean) => void;
  disabled?: boolean;
  setConsentInProgress?: (inProgress: boolean) => void;
}) => {
  const nonceGenerator = useNonceGenerator();
  const params = new URLSearchParams(window.location.search);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleAcceptConsent = async () => {
    setIsLoading(true);
    setConsentInProgress?.(true);
    try {
      await postConsent(config, true, user, nonceGenerator, params);
      setConsentAccepted(true);
      emitPostAuthRumEvent(user, PostAuthRumEvent.CONSENT_ACCEPTED);
      onContinue();
    } catch (error) {
      // If 409, the invitation was already accepted — treat as success
      if (error instanceof HttpError && error.status === 409) {
        setConsentAccepted(true);
        onContinue();
        return;
      }
      setIsLoading(false);
      setConsentInProgress?.(false);
    }
  };
  return (
    <Button
      onClick={handleAcceptConsent}
      variant="primary"
      data-testid={'accept-consent'}
      loading={isLoading}
      disabled={disabled}
    >
      {buttonLabel}
    </Button>
  );
};
